/**
 * Applies module listScope rules (Documents vs Procedures, etc.) on the same API dataset.
 */
export function matchesListScope(entity, listScope) {
  if (!listScope || !entity) return true;

  const {
    field = 'documentTypeId',
    include,
    exclude,
    includeNames,
    excludeNames,
    relationName = 'documentType',
    relationField = 'name',
    documentTypeFlag,
  } = listScope;

  if (documentTypeFlag) {
    return Boolean(entity[relationName]?.[documentTypeFlag]);
  }

  const idValue = entity[field];
  const relationValue = entity[relationName]?.[relationField];

  if (includeNames?.length) {
    return includeNames.includes(relationValue);
  }
  if (excludeNames?.length) {
    return !excludeNames.includes(relationValue);
  }
  if (include?.length) {
    return include.includes(idValue);
  }
  if (exclude?.length) {
    return !exclude.includes(idValue);
  }

  return true;
}

export function filterByListScope(entities, listScope) {
  if (!listScope || !Array.isArray(entities)) return entities;
  return entities.filter((entity) => matchesListScope(entity, listScope));
}
